module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1444-retro-min.0dbfa9cd.jpg";